import { useEffect } from "react";
import { useI18n } from "@/hooks/use-i18n";
import { HeaderBar } from "@/components/HeaderBar";
import { LegalLayout } from "@/components/LegalLayout";
import { Footer } from "@/components/Footer";

export default function TermsOfService() {
  const { t, tArray, dir, lang, setLang } = useI18n();

  useEffect(() => {
    document.title = `${t("legal.termsOfService.title")} - Aurelian Private Care`;
  }, [t, lang]);

  const sectionKeys = ["scope", "noDiagnosis", "noGuarantee", "fees", "confidentiality", "governingLaw", "disputes"] as const;
  const sections: Record<string, { title: string; items: string[] }> = {};
  for (const key of sectionKeys) {
    sections[key] = {
      title: t(`legal.termsOfService.sections.${key}.title`),
      items: tArray(`legal.termsOfService.sections.${key}.items`),
    };
  }

  return (
    <div className="flex flex-col min-h-screen" dir={dir}>
      <HeaderBar lang={lang} onChangeLang={setLang} dir={dir} />
      <LegalLayout
        title={t("legal.termsOfService.title")}
        intro={t("legal.termsOfService.intro")}
        lastUpdated={t("legal.lastUpdated")}
        backLabel={t("legal.backToHome")}
        sections={sections}
        dir={dir}
      />
      <Footer t={t} dir={dir} />
    </div>
  );
}
